module.exports = __webpack_public_path__ + "static/iulian-cda13261734f9d01dfb1613a74f4e798.png";